module.exports = __webpack_public_path__ + "assets/img/logitechworkspace-lp-lifestyle-w540.20745543.webp";